import { Checkbox } from "@arcadeai/design-system/components/ui/atoms/checkbox";
import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { Control } from "react-hook-form";
import type { CatalogGrantCreateInput } from "../../types";
import { CATALOG_SUBJECT_EVERYONE } from "../../types";

const EVERYONE_CHECKBOX_ID = "catalog-subject-everyone";

type SubjectFieldProps = {
  control: Control<CatalogGrantCreateInput>;
};

export const SubjectField = ({ control }: SubjectFieldProps) => (
  <FormField
    control={control}
    name="subject"
    render={({ field }) => {
      const isEveryone = field.value === CATALOG_SUBJECT_EVERYONE;

      return (
        <FormItem>
          <FormLabel>Audience</FormLabel>
          <div className="flex items-center gap-2">
            <Checkbox
              checked={isEveryone}
              id={EVERYONE_CHECKBOX_ID}
              onCheckedChange={(checked) =>
                field.onChange(checked ? CATALOG_SUBJECT_EVERYONE : "")
              }
            />
            <label
              className="cursor-pointer text-sm"
              htmlFor={EVERYONE_CHECKBOX_ID}
            >
              Everyone
            </label>
          </div>
          <FormControl>
            <Input
              disabled={isEveryone}
              name={field.name}
              onBlur={field.onBlur}
              onChange={field.onChange}
              placeholder="IdP group value (e.g. engineering)"
              ref={field.ref}
              value={isEveryone ? "" : (field.value ?? "")}
            />
          </FormControl>
          <FormDescription>
            Grant to a specific IdP group, or toggle Everyone to publish for all
            end-users.
          </FormDescription>
          <FormMessage />
        </FormItem>
      );
    }}
  />
);
